import { Box, Grid } from "@mui/material";
import RetmIntegrationCard from "./retm-card";
import FoodicsIntegrationCard from "./foodics-card";
import ZatcaIntegrationCard from "./zatca-card";

const IntegrationsTabs = () => {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <RetmIntegrationCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FoodicsIntegrationCard />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ZatcaIntegrationCard />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IntegrationsTabs;
